
import * as defaultImport from "@splunk/dashboard-utils";
export * from "@splunk/dashboard-utils";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
